module.exports = __webpack_public_path__ + "static/img/caseImg11.2054a28.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/caseImg11.jpg
// module id = OZ0r
// module chunks = 0